export default function useTokenSync() {
  const date = new Date()
  date.setTime(date.getTime() + 100 * 60 * 60 * 24 * 30)
  const apolloAuthCookie = useCookie(
    'apollo:customer.token',
    {
      path: '/',
      expires: date,
      httpOnly: false,
      sameSite: 'lax',
      secure: true,
    },
  )
  const checkoutAuthCookie = useCookie(
    'customer_token',
    {
      path: '/',
      expires: date,
      httpOnly: false,
      sameSite: 'lax',
      secure: true,
    },
  )

  const { logout } = useAccountLogout()

  onMounted(async () => {
    if (!checkoutAuthCookie.value) {
      await logout()
    }
    else {
      apolloAuthCookie.value = 'Bearer ' + checkoutAuthCookie.value
    }
  })

  watch(apolloAuthCookie, () => {
    if (apolloAuthCookie.value) {
      checkoutAuthCookie.value = apolloAuthCookie.value?.replace('Bearer ', '')
    }
  })
}
